
import {Injectable, Inject} from 'ng-metadata/core';
import {HttpService} from '../../infra/httpRequest/http.service';
import {Cheetah} from '../cheetah.service';
import {SearchStateService} from '../searchState.service';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

const indexOf = require('lodash/indexOf');
const assign = require('lodash/assign');
const getValue = require('lodash/get');


@Injectable()

export class SnippetService {
    private _snippets;
    private _highlight;
    constructor(private httpService : HttpService,
                @Inject('restBaseURLs') private restBaseURLs,
                private cheetah: Cheetah,
                private searchStateService : SearchStateService,
                
                private configurationUtil : ConfigurationUtil) {
    }
    
    get snippets() {
        return this._snippets;
    }
    
    set snippets(snippets) {
        this._snippets = snippets;
    }
 
    get highlights() {
        return this._highlight;
    }

    public updateSnippets(items, highlights) {
        if (!items) {
            return;
        }
        if (!this.configurationUtil.getBriefResultConfiguration()) {
            return;
        }        
        if (!this.configurationUtil.getBriefResultConfiguration().showsnip) {
            return;
        }
        
        items = this.handleItemsWithSnipInResp(items);
        
        let records =items.map((item, index, array) => this.getFieldsFromPnxAsArray(item));
        records = records.filter(this.filterByContexts);
        records = records.filter(this.filterOutCdiRecords);
        if (!records || records.length === 0) {
            if (highlights && highlights.snippet){
                this._highlight= highlights.snippet;
            }
            return;
        }
        
        this.httpService.callPostAndParams(this.restBaseURLs.snippetURL, this.cheetah.searchData, records)
               .then((data: any) => {
 
            if (this.searchStateService.getSearchObject().newSearch) {
                this.snippets=data;
            } else {
                if (!this.snippets) {
                    this.snippets = {};
                }
                assign(this.snippets, data);
                let hterms = this.snippets.highlight;
                this._highlight= hterms? hterms.substring(1,hterms.length-1).split(",") : undefined;
            }
        });
    }
    
    private handleItemsWithSnipInResp(items){
    	var itemsWithoutSnip = [];
    	for (var i=0; i<items.length; i++){
    		var item = items[i];
    		if (getValue(item, 'pnx.display.snippet')) {
    			if (!this.snippets) {
                    this.snippets = {};
                }
	    		this.snippets[item.pnx.control.recordid[0]] = item.pnx.display.snippet[0];
    		} else {
    			itemsWithoutSnip.push(item);
    		}
    	}
    	return itemsWithoutSnip;
    }
    
    private getFieldsFromPnxAsArray(item) {
        let rsrctype = getValue(item, 'pnx.search.rsrctype');
        if (rsrctype && rsrctype.length>0) {
        	rsrctype = rsrctype[0];
        }
        return {context: item.context,
                recordId: item.pnx.control.recordid[0],
                resourceType: rsrctype};
    }
    
    private filterByContexts(e) {
         return (indexOf(['L','PC'],e.context) >= 0);
    }

    private filterOutCdiRecords(e){
        return !e.recordId.startsWith("cdi_");
    }
    
}
//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/snippet/snippet.service.ts